import { BaseSopOperation } from "./_Base";
import { objectTypeFromConstructor } from "../../../core/geometry/Constant";
import { MapUtils } from "../../../core/MapUtils";
import { Group } from "three";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/BooleanValue";
import { CoreGeometryBuilderMerge } from "../../../core/geometry/builders/Merge";
export class MergeSopOperation extends BaseSopOperation {
  static type() {
    return "merge";
  }
  cook(inputCoreGroups, params) {
    let allObjects = [];
    for (let inputCoreGroup of inputCoreGroups) {
      if (inputCoreGroup) {
        const objects = inputCoreGroup.objects();
        if (isBooleanTrue(params.compact)) {
          for (let object of objects) {
            object.traverse((child) => {
              allObjects.push(child);
            });
          }
        } else {
          for (let object of inputCoreGroup.objects()) {
            allObjects.push(object);
          }
        }
      }
    }
    if (isBooleanTrue(params.compact)) {
      allObjects = this._makeCompact(allObjects);
    }
    return this.createCoreGroupFromObjects(allObjects);
  }
  _makeCompact(all_objects) {
    const materialsByObjectType = /* @__PURE__ */ new Map();
    const objectsByType = /* @__PURE__ */ new Map();
    const orderedObjectTypes = [];
    for (let object of all_objects) {
      object.traverse((object3d) => {
        if (object3d instanceof Group) {
          return;
        }
        const object2 = object3d;
        if (object2.geometry) {
          const objectType = objectTypeFromConstructor(object2.constructor);
          if (objectType) {
            if (!orderedObjectTypes.includes(objectType)) {
              orderedObjectTypes.push(objectType);
            }
            if (objectType) {
              const found_mat = materialsByObjectType.get(objectType);
              if (!found_mat) {
                materialsByObjectType.set(objectType, object2.material);
              }
              MapUtils.pushOnArrayAtEntry(objectsByType, objectType, object2);
            }
          }
        }
      });
    }
    const merged_objects = [];
    orderedObjectTypes.forEach((objectType) => {
      var _a, _b;
      const objects = objectsByType.get(objectType);
      if (objects) {
        const geometries = [];
        for (let object of objects) {
          const geometry = object.geometry;
          geometry.applyMatrix4(object.matrix);
          geometries.push(geometry);
        }
        try {
          const merged_geometry = CoreGeometryBuilderMerge.merge(geometries);
          if (merged_geometry) {
            const material = materialsByObjectType.get(objectType);
            const object = this.createObject(merged_geometry, objectType, material);
            object.matrixAutoUpdate = false;
            merged_objects.push(object);
          } else {
            (_a = this.states) == null ? void 0 : _a.error.set("merge failed, check that input geometries have the same attributes");
          }
        } catch (e) {
          (_b = this.states) == null ? void 0 : _b.error.set(e.message);
        }
      }
    });
    return merged_objects;
  }
}
MergeSopOperation.DEFAULT_PARAMS = {
  compact: false,
  keepHierarchy: false
};
MergeSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
